
import { createI18n } from 'vue-i18n';
import { useLocale } from '@/locales/useLocale';

// 初始加载默认语言内容
async function loadInitialLocale() {
    const defaultLocale = useLocale().locale.value;
    const module = await import(`./locales/${defaultLocale}`);
    return module.default;
  }
  
  const initialLocale = await loadInitialLocale();
  
  export default createI18n({
    legacy: false,
    locale: 'zh-CN', // 占位符，实际由 useLocale 控制
    fallbackLocale: 'zh-CN',
    messages: {
      'zh-CN': initialLocale,
    },
  });